import script from "./md-empty.vue?vue&type=script&lang=js"
export * from "./md-empty.vue?vue&type=script&lang=js"

import "./md-empty.vue?vue&type=style&index=0&id=56071b37&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/cms-preview/md-empty.vue'],['__file',"md-empty.vue"]])

export default __exports__